<template>
    <div class="fixed flex justify-center items-center z-10 top-0 left-0 w-full h-full bg-[#00000080]">
        <div class="w-full sm:w-[530px] mx-[20px] sm:mx-0 p-[30px] bg-white rounded-[10px] border-2 border-[#e96932]">
            <div class="flex justify-between items-center mt-[10px]">
                <span class="text-xl font-bold uppercase">{{ title }}</span> 
                <font-awesome-icon icon="fa-solid fa-xmark" class="h-[25px] cursor-pointer" @click="$emit('close')" />
            </div>
            <div class="inline-grid my-[30px]">
                <span>Non è stato possibile associare un veicolo alla targa</span><br>
                <span>Sono disponibili i seguenti dati sul veicolo</span>
                <span v-if="data?.targa">Targa: <strong>{{ data.targa }}</strong></span>
                <span v-if="data?.telaio">Telaio: <strong>{{ data.telaio }}</strong></span>
                <span v-if="data?.tipo">Tipo veicolo: <strong>{{ formatTipoMotore(data.tipo) }}</strong></span>
                <span v-if="data?.codiceMotore">Codice motore: <strong>{{ data.codiceMotore }}</strong></span>
                <span v-if="data?.codiceOmologazione">Codice omologazione: <strong>{{ data.codiceOmologazione }}</strong></span>
                <span v-if="data?.dataImmatricolazione">Data immatricolazione: <strong>{{ formatDate(data.dataImmatricolazione, "YYYY-MM-DD", "DD/MM/YYYY") }}</strong></span>
                <span v-if="data?.dataUltimaRevisione">Data ultima revisione: <strong>{{ formatDate(data.dataUltimaRevisione, "YYYY-MM-DD", "DD/MM/YYYY") }}</strong></span>
                <span class="flex items-center">Immatricolazione estera: 
                    <font-awesome-icon v-if="data?.immatricolazioneEstera == 'si'" icon="fa-solid fa-check" style="color:green; font-size: 18px; margin-left: 5px" />
                    <font-awesome-icon v-else icon="fa-solid fa-xmark" style="color:red; font-size: 18px; margin-left: 5px" />
                </span>
                <span v-if="data?.statoEstero">Stato estero: <strong>{{ data.statoEstero }}</strong></span>
                <span v-if="data?.targaEstero">Targa estero: <strong>{{ data.targaEstero }}</strong></span>
                <span v-if="data?.dataImmatricolazioneEstero">Data immatricolazione estero: <strong>{{ formatDate(data.dataImmatricolazioneEstero, "YYYY-MM-DD", "DD/MM/YYYY") }}</strong></span>
            </div>
            <div class="flex justify-end">
                <button class="button py-[5px] px-[10px]" @click="$emit('close')">Chiudi</button>
            </div>
        </div>
    </div>
</template>

<script>
import formatter from "../formatter";

export default {
    name: 'PopupView',
    props: ['title', 'data'],

    data() {
        return {
            tipi: [{ label: "Auto", value: "AUTOVETTURE" }, { label: "Moto", value: "MOTO" }, { label: "Commerciale", value: "VEICOLI_COMM_IND" }]
        }
    },

    methods: {
        formatDate(date, initialFormat, finalFormat) {
            if(!date) {
                return null;
            }
            return formatter.formatDate(date, initialFormat, finalFormat);
        },
        formatTipoMotore(tipo) {
            const result = this.tipi?.find(item => item?.value == tipo);

            if(result) {
                return result?.label;
            }    
            return null;        
        }
    }
}
</script>